import React from 'react';
export function Footer() {
  return <footer className="bg-black text-[#aaa] text-center py-5 px-[15px] text-[12px] font-poppins" data-id="element-106">
      <p className="mb-1" data-id="element-107">
        © 2026 - Pack Saludable | Todos los derechos reservados
      </p>
      <p data-id="element-108">Este es un producto digital. No se enviará ningún producto físico.</p>
    </footer>;
}